import {init} from './utils/whenLoaded';
import {initializePageLeaveConfirmation} from './initializePageLeaveConfirmation';
import adct from './calculators/adct';
import cdlqi from './calculators/cdlqi';
import dlqi from './calculators/dlqi';
import easi from './calculators/easi';
import napsi from './calculators/napsi';
import nrs from './calculators/nrs';
import patient from './calculators/patient';
import pasi from './calculators/pasi';
import pest from './calculators/pest';
import poem from './calculators/poem';
import pssi from './calculators/pssi';

import './bootstrap';

init();
initializePageLeaveConfirmation();

window.dermakalk = {
	adct,
	cdlqi,
	dlqi,
	easi,
	napsi,
	nrs,
	patient,
	pasi,
	pest,
	poem,
	pssi,
}
